/**
 * Created by Christof Sander on 02.02.2017.
 */

const utils = require('frontend-controller/lib/utils');

module.exports = {
	config: {
		environmentDependent: true

	},

	methods: {
		/**
		 * this function has to return true if the environment dependent refresh should be performed.
		 *
		 * @param   activeEnvironment               {} - active environment
		 * @param   newEnvironment                  {} - new environment
		 * @param   serverKnownEnvironment          {} - environment known by the server
		 * @param   initialExecution                boolean - is this the initial execution
		 * @param   externalDrivenCall              boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
		 * @param   environmentUpdateByParent       boolean - has a parent of mine decided to refresh and already updated by own activeEnvironment
		 * @returns boolean
		 */
		environmentRefreshNecessary: function(activeEnvironment, newEnvironment, serverKnownEnvironment, initialExecution, externalDrivenCall, environmentUpdateByParent){
			// check if loading options are in charge
			if(initialExecution && this.model._galleryImages.config.loadingOptions) return true;

			// check if multiple images are available
			var multipleImagesFound = false;
			utils.forEach(this.model.galleryImages, function(image){
				if(image.rendered && image.rendered.length > 1){
					multipleImagesFound = true;
					return false;
				}
			});
			if(!multipleImagesFound) return false;

			// check if environment has changed enough
			// breakPoint has been changed
			if(newEnvironment.breakPoint && activeEnvironment.breakPoint != newEnvironment.breakPoint && activeEnvironment.breakPointSize < newEnvironment.breakPointSize) return true;

			// fallback
			return false;
		}
	},

	hooks: {
		attach: function($element, options){

			var $imageList      = $element.find('.images div');
			var $titleContainer = $element.find('.titles').html('');
			var $sep = "";

			// each image
			$imageList.each(function(index){
				// create a title link
				var $a = $('<a></a>').text($(this).attr('title'));
				// first is underlined
				if ($sep=="") $a.addClass("active");
				// click-handler for title
				$a.on("click", function() {
					var $this = $(this);
					// if not active already
					if (!$this.hasClass("active")) {
						// remove existing active-classes
						$titleContainer.find('a').removeClass("active");
						$imageList.removeClass("active");
						// set new active classes
						$this.addClass("active");
						$element.find(".images div:eq(" + index + ")").addClass("active");
					}
				});
				// append "/" as separator
				$titleContainer.append($sep);
				$sep = $.parseHTML(' / ');
				// append the title-link to swap the images
				$titleContainer.append($a);
			});
		}
	}
};